<template>
  <div class="wrapper" style="background-color: #ffffff">
    <div class="section">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <img src="xalq_sigorta.png" alt="" />
          </div>
        </div>
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-100 justify-content-center mx-auto text-center"
          >
            <h2 class="title">
              Hörmətli <br />
              Xalid Əliyev, <br />
              Sizə Daşınmaz əmlakınız İCBARİ sığortasını <br />
              təklif edirik
            </h2>
            <h4>
              Daşınmaz əmlakın yanğın və ya digər hadisələr nəticəsində
              zədələnməsi, məhv olması, yaxud hər hansı formada itkisi ilə bağlı
              dəyən zərərin əvəzinin ödənilməsi məqsədi ilə tətbiq edilir
            </h4>
          </div>
        </div>
        <ValidationObserver v-slot="{ isvalid }" ref="observer">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <md-button
                class="md-warning"
                style="width: 100%"
                @click="smallAlert2 = true"
              >
                <h4>Mənim artıq <b>İCBARİ</b> sığortam var!</h4>
              </md-button>

              <div class="modal modal-bg" :class="{ show: smallAlert2 }">
                <modal
                  v-if="smallAlert2"
                  type="modal-small"
                  @close="smallAlert2 = false"
                >
                  <template slot="header">
                    <md-button
                      class="md-simple md-close md-just-icon md-round modal-default-button"
                      @click="smallAlert2 = false"
                    >
                      <md-icon>clear</md-icon>
                    </md-button>
                  </template>

                  <template slot="body">
                    <h3>
                      Xeyirli olsun! <br />
                      Təşəkkür edirik!
                    </h3>
                  </template>

                  <template slot="footer">
                    <div class="justify-content-center d-flex">
                      <md-button
                        @click="smallAlert2 = false"
                        class="md-success md-simple"
                      >
                        Bağla
                      </md-button>
                    </div>
                  </template>
                </modal>
              </div>
            </div>
            <div
              class="md-layout-item md-size-100 md-small-size-100 text-center"
            >
              <h4>
                yoxdursa <br />
                Məlumatları doldurun və SİFARİŞ düyməsini sıxın
              </h4>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <h3><b>1.</b> Mənzilin ünvanını qeyd edin</h3>
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100">
              <md-radio v-model="iscurrentaddress" :value="true">
                <span style="font-size: 14pt">
                  Bakı şəhəri, Ak. Həsən Əliyev 12, mən. 33
                </span>
              </md-radio>
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100">
              <div class="md-layout">
                <div class="md-layout-item md-size-10 md-small-size-100">
                  <md-radio v-model="iscurrentaddress" :value="false">
                    <span style="font-size: 14pt"> Digər </span>
                  </md-radio>
                </div>
                <div class="md-layout-item md-size-90 md-small-size-100" v-if="!iscurrentaddress">
                  <ValidationProvider
                    name="Ünvan"
                    rules="required"
                    v-slot="{ passed, failed }"
                  >
                    <md-field
                      
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>Ünvan</label>
                      <md-input v-model="address" />
                    </md-field>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100">
              <h3>
                <b>2.</b> Sənədin nömrəsi (Çıxarış (Kupça), Müqavilə nömrəsi)
              </h3>
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider
              :disabled="dontknow"
                name="Sənədin nömrəsi"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Sənədin nömrəsi</label>
                  <md-input v-model="docnumber" :disabled="dontknow"/>
                </md-field>
                <md-checkbox v-model="dontknow">Bilmirəm/Yadımda deyil</md-checkbox>
              </ValidationProvider>
            </div>
            <div
              class="md-layout-item md-size-100 md-small-size-100 md-alignment-center-center"
            >
              <md-button
                class="md-primary"
                style="width: 100%"
                :disabled="isvalid"
                @click="onSubmit"
              >
                <md-icon>thumb_up_alt</md-icon>
                SİFARİŞ
              </md-button>

              <div class="modal modal-bg" :class="{ show: smallAlert }">
                <modal
                  v-if="smallAlert"
                  type="modal-small"
                  @close="smallAlert = false"
                >
                  <template slot="header">
                    <md-button
                      class="md-simple md-close md-just-icon md-round modal-default-button"
                      @click="smallAlert = false"
                    >
                      <md-icon>clear</md-icon>
                    </md-button>
                  </template>

                  <template slot="body">
                    <div v-if="isformvalid">
                      <h3 style="color: #00c853">Təşəkkür edirik!</h3>
                      <h5>Yaxın dəqiqələr sizə geridönüş edəcəyik</h5>
                    </div>
                    <div v-else>
                      <h3 style="color: #f44336">Diqqət !</h3>
                      <h5 class="md-error">
                        <br />
                        Xahiş olunur, <b>Ünvan</b> və
                        <b>Sənədin nömrəsi</b> xanalarını doludurasınız
                      </h5>
                    </div>
                  </template>

                  <template slot="footer">
                    <div class="justify-content-center d-flex">
                      <md-button
                        @click="smallAlert = false"
                        class="md-success md-simple"
                      >
                        Bağla
                      </md-button>
                    </div>
                  </template>
                </modal>
              </div>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  validate,
} from "vee-validate/dist/vee-validate.full";
import { Modal } from "@/components";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Modal,
  },
  data() {
    return {
      smallAlert: false,
      smallAlert2: false,
      iscurrentaddress: true,
      docnumber: "",
      address: "",
      isformvalid: false,
      dontknow: false
    };
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate().then((isvalid) => {
        this.isformvalid = isvalid;
        this.smallAlert = true;
        console.log(isvalid);
      });
    },
  },
};
</script>

<style lang="scss">
.title-layout {
  height: 40px;

  width: 100%;
  height: 100%;
  display: block;
  background: #4caf50;
}
</style>